import React from 'react'
import { Link } from "react-router-dom"
import { AuthenticationService } from './auth/AuthenticationService'

import logo from "../assets/logo.svg"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

export default function Header() {

    const user = AuthenticationService.currentUser

    return (
        <>
        { user !== null && (    
        <header className="bg-white d-flex align-items-center p-4">
            <div className="mr-auto"><Link to="/"><img width="150" src={logo} alt="Logo ZEOP" /></Link></div>
            <div className="d-flex align-items-center">
                <div className="mr-2">Bonjour {user.firstname}</div>
                <Link title="Se déconnecter" className="btn btn-sm btn-danger" to="/signout"><FontAwesomeIcon icon={faSignOutAlt} /></Link>
            </div>
        </header>
        )}
        </>
    )
}